/** Angular */
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DsPaginatorService extends MatPaginatorIntl {
  /**
   * Creates an instance of DsPaginatorService.
   *
   * @param translate Translate service
   */
  constructor(private translate: TranslateService) {
    super();
    this.updateTranslations();
  }

  /**
   * Extends getRangeLabel from MatPaginatorIntl.
   * A label for the range of items within the current page and the length of the whole list.
   *
   * @param page Page number
   * @param pageSize Page size
   * @param length Total length
   * @returns string
   */
  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const of: string = this.translate ? this.translate.instant('matPaginator.of') : 'of';
    if (length === 0 || pageSize === 0) {
      return `0 ${of} ${length}`;
    }
    const displayedLength = Math.max(length, 0);
    const startIndex: number = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < displayedLength ? Math.min(startIndex + pageSize, displayedLength) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${of} ${displayedLength}`;
  };

  /**
   * Update translations everytime the language is changed.
   */
  private updateTranslations() {
    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
    this.translateLabels();
  }

  /**
   * Update the label translations.
   */
  private translateLabels() {
    this.itemsPerPageLabel = this.translate.instant('matPaginator.itemsPerPageLabel');
    this.nextPageLabel = this.translate.instant('matPaginator.nextPageLabel');
    this.previousPageLabel = this.translate.instant('matPaginator.previousPageLabel');
    this.lastPageLabel = this.translate.instant('matPaginator.lastPageLabel');
    this.firstPageLabel = this.translate.instant('matPaginator.firstPageLabel');
    this.changes.next();
  }
}
